var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconFilledDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#F60",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.334 17V2.667h11.333v10.88A3.455 3.455 0 0 1 12.21 17H4.334zm8.262-11.505a.621.621 0 0 1 .637.582.586.586 0 0 1-.583.609l-5.258.08a.622.622 0 0 1-.638-.582.585.585 0 0 1 .583-.608l5.259-.081zm.005 2.689a.621.621 0 0 1 .632.588.586.586 0 0 1-.588.603l-5.259.035a.622.622 0 0 1-.632-.588.585.585 0 0 1 .588-.603l5.26-.035zm0 2.667a.621.621 0 0 1 .632.588.586.586 0 0 1-.588.603l-5.259.035a.622.622 0 0 1-.632-.588.585.585 0 0 1 .588-.603l5.26-.035z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconFilledDocument);
export default __webpack_public_path__ + "static/media/atoms-icon-filled-document.a764bc3f7ae6703e22383d118225b0aa.svg";
export { ForwardRef as ReactComponent };